import React, { useState } from "react";
import {
  Button,
  CardActions,
  CardContent,
  CardProps,
  Typography,
} from "@material-ui/core";
import { useHistory, useLocation, useParams } from "react-router";
import { getEarningsSummary } from "../../../../sdk/earnings";
import DineroFactory from "dinero.js";
import { CardLoading } from "../../../../components/card-loading";

export const ArtistSummaryEarnings: React.FC<CardProps> = (props) => {
  const history = useHistory();
  const location = useLocation();

  const { artistId } = useParams<{ artistId: string }>();

  const [total, setTotal] = useState(
    DineroFactory({ amount: 0, precision: 2, currency: "USD" })
  );
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    setLoading(true);
    getEarningsSummary(artistId, "ARTIST")
      .then((summary) => {
        setTotal(
          summary.reduce(
            (memo, item) => memo.add(item.value),
            DineroFactory({ amount: 0, precision: 2, currency: "USD" })
          )
        );
      })
      .finally(() => setLoading(false));
  }, [artistId]);

  return (
    <CardLoading
      {...props}
      style={{ width: "200px", ...props.style }}
      loading={loading}
    >
      <CardContent>
        <Typography color="textSecondary" gutterBottom>
          Earnings
        </Typography>
        <Typography variant="h5" component="h2">
          {total.toFormat()}
        </Typography>
        <Typography color="textSecondary">Total</Typography>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          onClick={() => history.push(`/earnings/${artistId}`, location.state)}
        >
          View all
        </Button>
      </CardActions>
    </CardLoading>
  );
};
